"use strict";

/*
    WEBSITE TRAVELER REDESIGN
    created on: 01/09/2023
    Authors: ISC. Oswaldo Álvarez Juárez and ISC. EDGAR RODRIGO SALAZAR
    Email: oswaldo.aj29@outlook.com, salazarrodrigoisc@gmail.com

*/

/*===============================================
VARIABLES GENERALES
=================================================*/
let removePromo;

function StartEvents() {
    configureDatePickerSolicitudTravel();
    eventSendEmailSolicitudTravel();
}


function configureDatePickerSolicitudTravel() {
    $.datepicker.regional.es = {
        closeText: "Cerrar",
        prevText: "<Ant",
        nextText: "Sig>",
        currentText: "Hoy",
        monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
        monthNamesShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
        dayNames: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
        dayNamesShort: ["Dom", "Lun", "Mar", "Mié", "Juv", "Vie", "Sáb"],
        dayNamesMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sá"],
        weekHeader: "Sm",
        dateFormat: "dd-mm-yy",
        firstDay: 0,
        isRTL: !1,
        showMonthAfterYear: !1,
        yearSuffix: ""
    },
    $.datepicker.setDefaults($.datepicker.regional.es), $("#dateModalSolicitud").datepicker({
        showAnim: "slideDown",
        defaultDate: new Date,
        minDate: 0,
        altField: "#altFormatDateModalSolicitud",
        altFormat: "DD, d MM, yy",
        beforeShowDay: activeDays
    }), $("#tooltipMembership").tooltip({
        show: null,
        position: {
            my: "left top",
            at: "left bottom"
        },
        open: function(e, a) {
            a.tooltip.animate({
                top: a.tooltip.position().top + 10
            },
            "fast")
        }
    }), $(".tooltipModalReservations").tooltip({
        show: null,
        position: {
            my: "left top",
            at: "left bottom"
        },
        open: function(e, a) {
            a.tooltip.animate({
                top: a.tooltip.position().top + 10
            },
            "fast")
        }
    })
}

function eventSendEmailSolicitudTravel() {
    $("#sendSolicitudTravel").submit((function(e) {
        e.preventDefault();
        var a = $(this).attr("action"),
        t = 0,
        i = new FormData(document.getElementById("sendSolicitudTravel"));
        0 === $("#nameModalSolicitud").val().length ? (t++, $(".messagesModalSolicitud").text("Debe de escribir su nombre para poder solicitar la cotización."), $(".messagesModalSolicitud").removeClass("hidden"), $(".messagesModalSolicitud").addClass("alert-danger"), $("#nameModalSolicitud").addClass("border-red"), $("#nameModalSolicitud").focus()) : $("#nameModalSolicitud").removeClass("border-red"),
        0 === $("#emailModalSolicitud").val().length && !1 === emailIsValid($("#emailModalSolicitud").val()) ? (t++, $(".messagesModalSolicitud").text("Ingrese un email válido."), $(".messagesModalSolicitud").removeClass("hidden"), $(".messagesModalSolicitud").addClass("alert-danger"), $("#emailModalSolicitud").addClass("border-red"), $("#emailModalSolicitud").focus()) : $("#emailModalSolicitud").removeClass("border-red"),
        !1 === validateDate($("#dateModalSolicitud").val()) ? (t++, $(".messagesModalSolicitud").text("Ingrese una fecha válida."), $(".messagesModalSolicitud").removeClass("hidden"), $(".messagesModalSolicitud").addClass("alert-danger"), $("#dateModalSolicitud").addClass("border-red"), $("#dateModalSolicitud").focus()) : !1 === validateCurrentDate($("#dateModalSolicitud").val()) ? (t++, $(".messagesModalSolicitud").text("La fecha ingresada no puede ser igual a la fecha de hoy."), $(".messagesModalSolicitud").removeClass("hidden"), $(".messagesModalSolicitud").addClass("alert-danger"), $("#dateModalSolicitud").addClass("border-red"), $("#dateModalSolicitud").focus()) : $("#dateModalSolicitud").removeClass("border-red"),
        0 == t && ($(".messagesModalSolicitud").text(""), $(".messagesModalSolicitud").removeClass("alert-danger"), $.ajax({
            url: a,
            type: "POST",
            dataType: "json",
            data: i,
            cache: !1,
            contentType: !1,
            processData: !1,
            beforeSend: function() {
                $(".messagesModalSolicitud").html('<div class="sk-chase"><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div></div>')
            },
            success: function(e) {
                $(".messagesModalSolicitud").addClass("alert-success"),
                $(".messagesModalSolicitud").html(e.messages),
                $("#dateModalSolicitud").val("")
            },
            error: function(e) {
                $(".messagesModalSolicitud").addClass("alert-danger"),
                $(".messagesModalSolicitud").html("Error al enviar la solicitud de cotización. Intente nuevamente, si el problema persiste pongase en contacto con el departamento de atención a socios para reportar el problema y/o con el departamento de reservaciones para solicitar su cotización.")
            }
        }))
    }))
}

function activeDays(e) {
    let a = $("#departureDate").text().toLowerCase(),
    t = new Array,
    i = 0;
    if (-1 != a.indexOf("domingo") && (t[i] = 0, i++), -1 != a.indexOf("lunes") && (t[i] = 1, i++), -1 != a.indexOf("martes") && (t[i] = 2, i++), -1 == a.indexOf("miercoles") && -1 == a.indexOf("miércoles") || (t[i] = 3, i++), -1 != a.indexOf("jueves") && (t[i] = 4, i++), -1 != a.indexOf("viernes") && (t[i] = 5, i++), -1 == a.indexOf("sabado") && -1 == a.indexOf("sábado") || (t[i] = 6, i++), (-1 != a.indexOf("diarias") || -1 != a.indexOf("dárias") || -1 != a.indexOf("pregunte") || a.indexOf("pregúnte") || a.indexOf("pregunté")) && (t[i] = 0, i++, t[i] = 1, i++, t[i] = 2, i++, t[i] = 3, i++, t[i] = 4, i++, t[i] = 5, i++, t[i] = 6, i++), t.length > 0) return [-1 != $.inArray(e.getDay(), t)]; {
        let t = !1,
        i = a.split(";"),
        s = new Array;
        for (let a = 0; a < i.length; a++) {
            let o = determineYearMonth(i[a].split(":")[0]),
            n = i[a].split(":")[1].split(",");
            s[a] = {
                year: o[0],
                month: o[1],
                days: n
            };
            e.getYear();
            if (1900 == o[0] - e.getYear() && e.getMonth() == o[1]) for (let a = 0; a < n.length; a++) if (e.getDate() == parseInt(n[a])) {
                t = !0;
                break
            }
        }
        return [t]
    }
}

function determineYearMonth(e) {
    let a = {
        0: 2021,
        1: null
    };
    switch (e.trim().split(" ")[0].trim()) {
    case "enero":
        case "ene":
        a[1] = 0;
        break;
    case "febrero":
        case "feb":
        a[1] = 1;
        break;
    case "marzo":
        case "mar":
        a[1] = 2;
        break;
    case "abril":
        case "abr":
        a[1] = 3;
        break;
    case "mayo":
        case "may":
        a[1] = 4;
        break;
    case "junio":
        case "jun":
        a[1] = 5;
        break;
    case "julio":
        case "jul":
        a[1] = 6;
        break;
    case "agosto":
        case "ago":
        a[1] = 7;
        break;
    case "septiembre":
        case "sept":
        a[1] = 8;
        break;
    case "octubre":
        case "oct":
        a[1] = 9;
        break;
    case "noviembre":
        case "nov":
        a[1] = 10;
        break;
    case "diciembre":
        case "dic":
        a[1] = 11
    }
    return a
}

function validateDate(e) {
    var a = e.split("-");
    if (3 === a.length) {
        var t = a[0],
        i = a[1],
        s = a[2];
        return ! (t - 0 > (e = new Date(s, i, "0")).getDate() - 0)
    }
    return !1
}

function validateCurrentDate(e) {
    var a = new Date,
    t = e.split("-");
    return a.setFullYear(t[2], t[1] - 1, t[0]),
    a > new Date
}

function emailIsValid(e) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)
}


$(document).ready((function() {
    StartEvents()
})); //# sourceMappingURL=inicio.js.map
